import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface DateRangeConfig {
  minDate?: string;  // Format: 'YYYY-MM-DDTHH:mm:ss'
  maxDate?: string;  // Format: 'YYYY-MM-DDTHH:mm:ss'
}

export function dateRangeValidator(config: DateRangeConfig): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = new Date(control.value);
    const errors: ValidationErrors = {};

    if (config.minDate) {
      const minDate = new Date(config.minDate);
      if (value < minDate) {
        errors['minDate'] = {
          min: config.minDate,
          actual: control.value
        };
      }
    }

    if (config.maxDate) {
      const maxDate = new Date(config.maxDate);
      if (value > maxDate) {
        errors['maxDate'] = {
          max: config.maxDate,
          actual: control.value
        };
      }
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };
}